import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=97afb618&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"
import style0 from "./Preloader.vue?vue&type=style&index=0&id=97afb618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97afb618",
  null
  
)

export default component.exports